import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import "./Css/Gallery.css";
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight, faTimes, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const imageCount = 20;
const images = [];
for (let i = 1; i <= imageCount; i++) {
  images.push(require(`../Images/gallery/${i}.jpg`));
}

const PER_PAGE = 6;

const Gallery = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null); // Use index instead of src

  const indexOfLastImage = currentPage * PER_PAGE;
  const indexOfFirstImage = indexOfLastImage - PER_PAGE;
  const currentImages = images.slice(indexOfFirstImage, indexOfLastImage);
  const totalPages = Math.ceil(images.length / PER_PAGE);

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
  };

  

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedImageIndex !== null) {
        if (e.key === 'ArrowRight') {
          setSelectedImageIndex((prev) => (prev + 1) % images.length);
        } else if (e.key === 'ArrowLeft') {
          setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length);
        } else if (e.key === 'Escape') {
          setSelectedImageIndex(null);
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
    
  }, [selectedImageIndex]);

  return (
    <section className='section-pad'>
      <Container>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {currentImages.map((src, index) => {
            const actualIndex = indexOfFirstImage + index;
            return (
              <img
                key={index}
                src={src}
                alt={`img-${index}`}
                style={{ width: '100%', borderRadius: '8px', cursor: 'pointer' }}
                onClick={() => setSelectedImageIndex(actualIndex)} // Open popup with image index
              />
            );
          })}
        </Masonry>

        {/* Pagination Controls */}
        <div style={{ marginTop: '20px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              cursor: currentPage === 1 ? 'default' : 'pointer',
              color: currentPage === 1 ? '#aaa' : '#333',
            }}
          >
            <FontAwesomeIcon icon={faArrowAltCircleLeft} size='2x' />
          </button>

          <div>
            {Array.from({ length: totalPages }, (_, i) => (
              <span
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                style={{
                  display: 'inline-block',
                  margin: '0 6px',
                  cursor: 'pointer',
                  fontSize: '24px',
                  color: i + 1 === currentPage ? '#333' : '#ccc',
                }}
              >
                •
              </span>
            ))}
          </div>

          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '16px',
              cursor: currentPage === totalPages ? 'default' : 'pointer',
              color: currentPage === totalPages ? '#aaa' : '#333',
            }}
          >
            <FontAwesomeIcon icon={faArrowAltCircleRight} size='2x' />
          </button>
        </div>

        {/* Modal with navigation */}
        {selectedImageIndex !== null && (
          <div className="image-popup-overlay" onClick={() => setSelectedImageIndex(null)}>
            <div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={() => setSelectedImageIndex(null)}>
                <FontAwesomeIcon icon={faTimes} />
              </button>

              {/* Prev Button */}
              <button
                className="nav-btn left"
                onClick={() =>
                  setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length)
                }
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>

              {/* Image */}
              <img src={images[selectedImageIndex]} alt="popup" className="popup-img" />

              {/* Next Button */}
              <button
                className="nav-btn right"
                onClick={() => setSelectedImageIndex((prev) => (prev + 1) % images.length)}
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        )}
      </Container>
    </section>
  );
};

export default Gallery;
